<template>
    <div class="score card" :style="{ backgroundColor: getColorByScore(value)}">
        <div class="d-flex flex-column align-content-center ">
            <h5 class="col text-center">
                Reifegrad {{ phase }}
            </h5>
            <div class="col text-center">
                <h5>
                    {{ value }}
                </h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Score",
    props: ["value", "phase"],
    data:function(){
        return {
            content: this.value,
            color: ""
        };
    },
    methods:{
        handleInput(e) {
            this.$emit('input', this.content)
        },
        getColorByScore(score){
            if(score >= 3) return '#C3E3DC';
            else if(score >= 1.5) return '#E3E1B8';
            else return '#E3BBAC';
        }
    }
};
</script>
